import { render, staticRenderFns } from "./TimeFormatSetting.vue?vue&type=template&id=62a80afa&scoped=true&"
import script from "./TimeFormatSetting.vue?vue&type=script&lang=js&"
export * from "./TimeFormatSetting.vue?vue&type=script&lang=js&"
import style0 from "./TimeFormatSetting.vue?vue&type=style&index=0&id=62a80afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a80afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a80afa')) {
      api.createRecord('62a80afa', component.options)
    } else {
      api.reload('62a80afa', component.options)
    }
    module.hot.accept("./TimeFormatSetting.vue?vue&type=template&id=62a80afa&scoped=true&", function () {
      api.rerender('62a80afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/TimeFormat/TimeFormatSetting.vue"
export default component.exports